import React from 'react';
import { Link } from 'react-router-dom';
import { Video, Phone, Mail, Instagram, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-zinc-950 border-t border-zinc-800 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 text-2xl font-bold mb-4">
              <Video className="w-8 h-8 text-light-pink" />
              <span>Yastudio</span>
            </Link>
            <p className="text-gray-400 mb-4">
              Vidéaste mariage professionnel en Alsace et Grand Est
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-light-pink transition-colors">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-gray-400 hover:text-light-pink transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-light-pink transition-colors">
                  À Propos
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-light-pink transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>Film de Mariage</li>
              <li>Prises de Vue Drone</li>
              <li>Couverture Événementielle</li>
              <li>Post-Production Pro</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:0603094298" className="flex items-center gap-2 text-gray-400 hover:text-light-pink transition-colors">
                  <Phone className="w-4 h-4" />
                  06 03 09 42 98
                </a>
              </li>
              <li>
                <a href="mailto:yastudio@outlook.fr" className="flex items-center gap-2 text-gray-400 hover:text-light-pink transition-colors">
                  <Mail className="w-4 h-4" />
                  yastudio@outlook.fr
                </a>
              </li>
              <li>
                <a 
                  href="https://www.instagram.com/yastudio_photographe_videaste/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-400 hover:text-light-pink transition-colors"
                >
                  <Instagram className="w-4 h-4" />
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-zinc-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Yastudio. Tous droits réservés.
          </p>
          <p className="text-gray-400 text-sm flex items-center gap-1">
            Créé avec <Heart className="w-4 h-4 text-light-pink" /> en Alsace
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;